import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/DashboardLayout';
import requests, { getApiBaseUrl } from '../../../services/httpServices';
import './quizBackdoor.css';

const QuizBackdoor = () => {
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchAllQuizzes();
  }, []);

  const fetchAllQuizzes = async () => {
    try {
      setLoading(true);
      setError(null);

      // Use axios instance which handles auth and IP address
      const response = await requests.get('quiz-backdoor/all');
      setQuizzes(response.quizzes || []);
    } catch (err) {
      console.error('Error fetching quizzes:', err);
      if (err.response?.status === 403) {
        setError('Access denied. Sysadmin role required.');
      } else {
        setError(err.message || 'Failed to load quizzes');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSelectQuiz = (quiz) => {
    setSelectedQuiz(quiz);
  };

  const handleBack = () => {
    setSelectedQuiz(null);
  };

  if (loading) {
    return (
      <DashboardLayout role={user.role}>
        <div className="quiz-backdoor-container">
          <div className="loading">Loading quizzes...</div>
        </div>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout role={user.role}>
        <div className="quiz-backdoor-container">
          <div className="error-message">{error}</div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout role={user.role}>
      <div className="quiz-backdoor-container">
        <h1>Quiz Verification Tool</h1>
        <p className="subtitle">Verify quiz content and answers</p>

        {!selectedQuiz ? (
          <div className="quizzes-list">
            <div className="quizzes-grid">
              {quizzes.map((quiz) => (
                <div
                  key={quiz.id}
                  className="quiz-card"
                  onClick={() => handleSelectQuiz(quiz)}
                >
                  <h3>{quiz.videoName}</h3>
                  <p className="question-count">{quiz.questionCount} questions</p>
                  <button className="view-btn">View Details</button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="quiz-details">
            <button className="back-btn" onClick={handleBack}>← Back to Quizzes</button>
            <h2>{selectedQuiz.videoName}</h2>
            <div className="questions-container">
              {selectedQuiz.questions.map((question, qIdx) => (
                <div key={qIdx} className="question-block">
                  <div className="question-header">
                    <h4>Question {qIdx + 1}</h4>
                  </div>
                  <p className="question-text">{question.questionText}</p>
                  <div className="options-list">
                    {question.options.map((option, oIdx) => (
                      <div
                        key={oIdx}
                        className={`option ${option.isCorrect ? 'correct' : ''}`}
                      >
                        <span className="option-letter">
                          {String.fromCharCode(65 + oIdx)})
                        </span>
                        <span className="option-text">{option.text}</span>
                        {option.isCorrect && (
                          <span className="correct-badge">✓ Correct</span>
                        )}
                      </div>
                    ))}
                  </div>
                  {question.explanation && (
                    <div className="explanation">
                      <strong>Explanation:</strong> {question.explanation}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default QuizBackdoor;
